import React, { Suspense } from 'react'
import { Text } from '@mantine/core'
import dynamic from 'next/dynamic'

import * as Types from '../../declarations'

import SectionHeader from './components/SectionHeader'

const RouteVisualisationMap = dynamic(
	() => import('./components/RouteVisualisationMap'),
	{ ssr: false },
)

interface Props {
	trip: Types.DB.Models.TripAttributes
}

const Route = ({
	trip: {
		name,
		jsonData: { route, trekOrClimb },
	},
}: Props) => {
	if (!route) return <></>

	const isTrek = trekOrClimb === 'TREK'
	const isSummitOnly = route.locations.length < 2

	return (
		<div
			id="route-visualiation-wrapper"
			className="spacing-between-sections-above"
		>
			<SectionHeader
				title={`${name} route `}
				section={Types.App.DataTypes.FeedbackSection.ROUTE_MAP}
			/>

			{!isTrek && (
				<>
					{!isSummitOnly && (
						<Text mb="xl">
							Explore the 3D route map for a realistic view of the ascent to{' '}
							{name}. This interactive map provides a close-up look at key
							points like base camp and high-altitude camps along the way. For
							those planning their own {isTrek ? 'trek' : 'expeditions'}, it
							offers a helpful overview of the {isTrek ? 'treks' : `mountain's`}{' '}
							terrain and surroundings.
						</Text>
					)}

					{isSummitOnly && (
						<Text mb="xl">
							View the summit location and surrounding terrain to get a sense of
							the mountain&apos;s environment. This map offers a valuable
							perspective on the peak&apos;s position within the region, aiding
							climbers in visualizing their route and nearby landmarks.
						</Text>
					)}
				</>
			)}

			{route?.description && <p>{route.description}</p>}
			<Suspense fallback={<div>Loading route map...</div>}>
				<RouteVisualisationMap route={route} isOpen={true} />
			</Suspense>
		</div>
	)
}

export default Route
